import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import FilterIcon from '../../images/filter.inline.svg';
import PinIcon from '../../images/pin.inline.svg';
import { LINKS_COLOR } from '../../theme';
import { MapModalWindow } from './MapModalWindow';
import { FiltersModalWindow } from './FiltersModalWindow';

const ButtonsRow = styled.div`
  position: fixed;
  left: 0;
  bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  z-index: 2;
`;

const Button = styled.button`
  padding: 8px 15px 8px 8px;
  margin: 0 8px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.14;
  color: #fff;
  background: ${LINKS_COLOR};
  border: none;
  border-radius: 20px;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(155, 132, 135, 0.06), 0 4px 12px 0 rgba(119, 94, 98, 0.05);
`;

const StyledFilterIcon = styled(FilterIcon)`
  width: 24px;
  height: 24px;
  fill: #fff;
`;

const StyledPinIcon = styled(PinIcon)`
  width: 24px;
  height: 24px;
  fill: #fff;
`;

const MobileActions = (props) => {
  const {
    updateExamCentersByCoordinates, examCentersData,
  } = props;

  const [isMapOpened, setMapOpened] = useState(false);
  const [isFiltersOpened, setFiltersOpened] = useState(false);

  const toggleMapModal = () => {
    setMapOpened(!isMapOpened);
  };

  const toggleFiltersOpened = () => {
    setFiltersOpened(!isFiltersOpened);
  };

  return (
    <div>
      <ButtonsRow>
        <Button onClick={toggleFiltersOpened} type="button">
          <StyledFilterIcon />
          Filtres
        </Button>
        <Button onClick={toggleMapModal} type="button">
          <StyledPinIcon />
          Сarte
        </Button>
      </ButtonsRow>
      {isMapOpened && (
        <MapModalWindow
          updateExamCentersByCoordinates={updateExamCentersByCoordinates}
          examCentersData={examCentersData}
          toggleMapPopup={toggleMapModal}
        />
      )}
      {isFiltersOpened
        && (
        <FiltersModalWindow
          onClose={toggleFiltersOpened}
        />
        )}
    </div>
  );
};

MobileActions.propTypes = {
  updateExamCentersByCoordinates: PropTypes.func.isRequired,
  examCentersData: PropTypes.array.isRequired,
};

export { MobileActions };
